module.exports = __webpack_public_path__ + "img/80_29.99ece66a.png";